'use client';
import React from 'react';

import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import { Container } from '@/components/Container';
import { SubscribeLayouts } from '@/components/Layouts/SubscribeLayouts';
import Section from '@/components/Section/Section';
import { Detailed } from '@/features/Blog/components/Detailed';
import { Reviews } from '@/features/Reviews/Reviews';
import { Subscribe } from '@/features/Subscribe/Subscribe';
import { IRoutePath } from '@/types/router';

export const TutorialDetailPage = ({ data, articles }) => {
  return (
    <>
      <Container>
        <Section>
          <Breadcrumb homeElement={IRoutePath.TUTORIAL} />
          <Detailed type="tutorial" data={data} articles={articles} />
        </Section>
      </Container>
      <Container>
        <Reviews />
      </Container>

      <SubscribeLayouts>
        <Container>
          <Subscribe />
        </Container>
      </SubscribeLayouts>
    </>
  );
};
